<template>
  <div>
    <ul class="lightrope">
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
      <li></li>
    </ul>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <div class="snow"></div>
    <section class="hero has-background-grey-lighter is-fullheight" style="display: flex;
    flex-direction: column;
    justify-content: center;">
      <div class="content">
        <!-- <br><br><br><br><br><br> -->
        <div class="container has-text-centered">
          <slot name="contenido"></slot>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  name: "PlantillaLogin",
};
</script>
<style scoped>
.has-background-grey-lighter {
  background-color: #de2f32 !important;
}
html,
body {
  font-family: "Questrial", sans-serif;
  font-size: 14px;
  font-weight: 300;
}
.hero.is-success {
  background: #f2f6fa;
}
.hero .nav,
.hero.is-success .nav {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.box {
  margin-top: 5rem;
}
.avatar {
  margin-top: -70px;
  padding-bottom: 20px;
}
.avatar img {
  padding: 5px;
  background: #fff;
  border-radius: 50%;
  -webkit-box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1),
    0 0 0 1px rgba(10, 10, 10, 0.1);
  box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
}
input {
  font-weight: 300;
}
p {
  font-weight: 700;
}
p.subtitle {
  padding-top: 1rem;
}

.login-hr {
  border-bottom: 1px solid black;
}

.has-text-black {
  color: black;
}

.field {
  padding-bottom: 10px;
}

.fa {
  margin-left: 5px;
}
/* LIGHTS START */
.lightrope {
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  position: absolute;
  z-index: 1;
  margin: -15px 0 0 0;
  padding: 0;
  pointer-events: none;
  width: 100%;
}
.lightrope li {
  position: relative;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
  list-style: none;
  margin: 0;
  padding: 0;
  display: block;
  width: 12px;
  height: 28px;
  border-radius: 50%;
  margin: 20px;
  display: inline-block;
  background: #00f7a5;
  box-shadow: 0px 4.6666666667px 24px 3px #00f7a5;
  -webkit-animation-name: flash-1;
  animation-name: flash-1;
  -webkit-animation-duration: 2s;
  animation-duration: 2s;
}
.lightrope li:nth-child(2n + 1) {
  background: cyan;
  box-shadow: 0px 4.6666666667px 24px 3px rgba(0, 255, 255, 0.5);
  -webkit-animation-name: flash-2;
  animation-name: flash-2;
  -webkit-animation-duration: 0.4s;
  animation-duration: 0.4s;
}
.lightrope li:nth-child(4n + 2) {
  background: #f70094;
  box-shadow: 0px 4.6666666667px 24px 3px #f70094;
  -webkit-animation-name: flash-3;
  animation-name: flash-3;
  -webkit-animation-duration: 1.1s;
  animation-duration: 1.1s;
}
.lightrope li:nth-child(odd) {
  -webkit-animation-duration: 1.8s;
  animation-duration: 1.8s;
}
.lightrope li:nth-child(3n + 1) {
  -webkit-animation-duration: 1.4s;
  animation-duration: 1.4s;
}
.lightrope li:before {
  content: "";
  position: absolute;
  background: #222;
  width: 10px;
  height: 9.3333333333px;
  border-radius: 3px;
  top: -4.6666666667px;
  left: 1px;
}
.lightrope li:after {
  content: "";
  top: -14px;
  left: 9px;
  position: absolute;
  width: 52px;
  height: 18.6666666667px;
  border-bottom: solid #222 2px;
  border-radius: 50%;
}
.lightrope li:last-child:after {
  content: none;
}
.lightrope li:first-child {
  margin-left: -40px;
}

@-webkit-keyframes flash-1 {
  0%,
  100% {
    background: #00f7a5;
    box-shadow: 0px 4.6666666667px 24px 3px #00f7a5;
  }
  50% {
    background: rgba(0, 247, 165, 0.4);
    box-shadow: 0px 4.6666666667px 24px 3px rgba(0, 247, 165, 0.2);
  }
}

@keyframes flash-1 {
  0%,
  100% {
    background: #00f7a5;
    box-shadow: 0px 4.6666666667px 24px 3px #00f7a5;
  }
  50% {
    background: rgba(0, 247, 165, 0.4);
    box-shadow: 0px 4.6666666667px 24px 3px rgba(0, 247, 165, 0.2);
  }
}
@-webkit-keyframes flash-2 {
  0%,
  100% {
    background: cyan;
    box-shadow: 0px 4.6666666667px 24px 3px cyan;
  }
  50% {
    background: rgba(0, 255, 255, 0.4);
    box-shadow: 0px 4.6666666667px 24px 3px rgba(0, 255, 255, 0.2);
  }
}
@keyframes flash-2 {
  0%,
  100% {
    background: cyan;
    box-shadow: 0px 4.6666666667px 24px 3px cyan;
  }
  50% {
    background: rgba(0, 255, 255, 0.4);
    box-shadow: 0px 4.6666666667px 24px 3px rgba(0, 255, 255, 0.2);
  }
}
@-webkit-keyframes flash-3 {
  0%,
  100% {
    background: #f70094;
    box-shadow: 0px 4.6666666667px 24px 3px #f70094;
  }
  50% {
    background: rgba(247, 0, 148, 0.4);
    box-shadow: 0px 4.6666666667px 24px 3px rgba(247, 0, 148, 0.2);
  }
}
@keyframes flash-3 {
  0%,
  100% {
    background: #f70094;
    box-shadow: 0px 4.6666666667px 24px 3px #f70094;
  }
  50% {
    background: rgba(247, 0, 148, 0.4);
    box-shadow: 0px 4.6666666667px 24px 3px rgba(247, 0, 148, 0.2);
  }
}

.snow {
  position: absolute;
  width: 10px;
  height: 10px;
  background: white;
  border-radius: 50%;
}
.snow:nth-child(1) {
  opacity: 0.7256;
  transform: translate(47.6501vw, -10px) scale(0.1163);
  animation: fall-1 26s -27s linear infinite;
}
@keyframes fall-1 {
  61.484% {
    transform: translate(43.9098vw, 61.484vh) scale(0.1163);
  }
  to {
    transform: translate(45.77995vw, 100vh) scale(0.1163);
  }
}
.snow:nth-child(2) {
  opacity: 0.139;
  transform: translate(70.5233vw, -10px) scale(0.9727);
  animation: fall-2 22s -13s linear infinite;
}
@keyframes fall-2 {
  55.432% {
    transform: translate(79.9925vw, 55.432vh) scale(0.9727);
  }
  to {
    transform: translate(75.2579vw, 100vh) scale(0.9727);
  }
}
.snow:nth-child(3) {
  opacity: 0.1219;
  transform: translate(72.4875vw, -10px) scale(0.7964);
  animation: fall-3 17s -1s linear infinite;
}
@keyframes fall-3 {
  35.172% {
    transform: translate(79.4006vw, 35.172vh) scale(0.7964);
  }
  to {
    transform: translate(75.94405vw, 100vh) scale(0.7964);
  }
}
.snow:nth-child(4) {
  opacity: 0.3304;
  transform: translate(20.4611vw, -10px) scale(0.6949);
  animation: fall-4 23s -3s linear infinite;
}
@keyframes fall-4 {
  48.736% {
    transform: translate(16.7523vw, 48.736vh) scale(0.6949);
  }
  to {
    transform: translate(18.6067vw, 100vh) scale(0.6949);
  }
}
.snow:nth-child(5) {
  opacity: 0.352;
  transform: translate(15.3066vw, -10px) scale(0.0752);
  animation: fall-5 16s -15s linear infinite;
}
@keyframes fall-5 {
  45.121% {
    transform: translate(18.9598vw, 45.121vh) scale(0.0752);
  }
  to {
    transform: translate(17.1332vw, 100vh) scale(0.0752);
  }
}
.snow:nth-child(6) {
  opacity: 0.4765;
  transform: translate(35.0243vw, -10px) scale(0.1112);
  animation: fall-6 15s -15s linear infinite;
}
@keyframes fall-6 {
  51.136% {
    transform: translate(37.8456vw, 51.136vh) scale(0.1112);
  }
  to {
    transform: translate(36.43495vw, 100vh) scale(0.1112);
  }
}
.snow:nth-child(7) {
  opacity: 0.2566;
  transform: translate(97.0186vw, -10px) scale(0.6556);
  animation: fall-7 11s -21s linear infinite;
}
@keyframes fall-7 {
  47.046% {
    transform: translate(92.8202vw, 47.046vh) scale(0.6556);
  }
  to {
    transform: translate(94.9194vw, 100vh) scale(0.6556);
  }
}
.snow:nth-child(8) {
  opacity: 0.3398;
  transform: translate(90.4854vw, -10px) scale(0.6204);
  animation: fall-8 18s -4s linear infinite;
}
@keyframes fall-8 {
  43.314% {
    transform: translate(92.6281vw, 43.314vh) scale(0.6204);
  }
  to {
    transform: translate(91.55675vw, 100vh) scale(0.6204);
  }
}
.snow:nth-child(9) {
  opacity: 0.6517;
  transform: translate(27.1568vw, -10px) scale(0.6814);
  animation: fall-9 15s -15s linear infinite;
}
@keyframes fall-9 {
  32.298% {
    transform: translate(27.59vw, 32.298vh) scale(0.6814);
  }
  to {
    transform: translate(27.3734vw, 100vh) scale(0.6814);
  }
}
.snow:nth-child(10) {
  opacity: 0.9114;
  transform: translate(87.5002vw, -10px) scale(0.556);
  animation: fall-10 16s -14s linear infinite;
}
@keyframes fall-10 {
  58.922% {
    transform: translate(82.5154vw, 58.922vh) scale(0.556);
  }
  to {
    transform: translate(85.0078vw, 100vh) scale(0.556);
  }
}
.snow:nth-child(11) {
  opacity: 0.7328;
  transform: translate(98.5352vw, -10px) scale(0.0098);
  animation: fall-11 16s -28s linear infinite;
}
@keyframes fall-11 {
  48.401% {
    transform: translate(99.0496vw, 48.401vh) scale(0.0098);
  }
  to {
    transform: translate(98.7924vw, 100vh) scale(0.0098);
  }
}
.snow:nth-child(12) {
  opacity: 0.8348;
  transform: translate(70.8458vw, -10px) scale(0.6481);
  animation: fall-12 26s -4s linear infinite;
}
@keyframes fall-12 {
  52.714% {
    transform: translate(75.9538vw, 52.714vh) scale(0.6481);
  }
  to {
    transform: translate(73.3998vw, 100vh) scale(0.6481);
  }
}
.snow:nth-child(13) {
  opacity: 0.9109;
  transform: translate(73.6589vw, -10px) scale(0.6693);
  animation: fall-13 21s -20s linear infinite;
}
@keyframes fall-13 {
  35.55% {
    transform: translate(71.8115vw, 35.55vh) scale(0.6693);
  }
  to {
    transform: translate(72.7352vw, 100vh) scale(0.6693);
  }
}
.snow:nth-child(14) {
  opacity: 0.0712;
  transform: translate(56.3702vw, -10px) scale(0.82);
  animation: fall-14 22s -3s linear infinite;
}
@keyframes fall-14 {
  49.805% {
    transform: translate(57.9501vw, 49.805vh) scale(0.82);
  }
  to {
    transform: translate(57.16015vw, 100vh) scale(0.82);
  }
}
.snow:nth-child(15) {
  opacity: 0.9703;
  transform: translate(84.5096vw, -10px) scale(0.6669);
  animation: fall-15 15s -12s linear infinite;
}
@keyframes fall-15 {
  79.945% {
    transform: translate(79.5305vw, 79.945vh) scale(0.6669);
  }
  to {
    transform: translate(82.02005vw, 100vh) scale(0.6669);
  }
}
.snow:nth-child(16) {
  opacity: 0.9318;
  transform: translate(50.7965vw, -10px) scale(0.005);
  animation: fall-16 12s -3s linear infinite;
}
@keyframes fall-16 {
  56.123% {
    transform: translate(42.0447vw, 56.123vh) scale(0.005);
  }
  to {
    transform: translate(46.4206vw, 100vh) scale(0.005);
  }
}
.snow:nth-child(17) {
  opacity: 0.3658;
  transform: translate(3.1805vw, -10px) scale(0.5763);
  animation: fall-17 14s -28s linear infinite;
}
@keyframes fall-17 {
  60.958% {
    transform: translate(10.2113vw, 60.958vh) scale(0.5763);
  }
  to {
    transform: translate(6.6959vw, 100vh) scale(0.5763);
  }
}
.snow:nth-child(18) {
  opacity: 0.2195;
  transform: translate(48.3294vw, -10px) scale(0.73);
  animation: fall-18 22s -16s linear infinite;
}
@keyframes fall-18 {
  43.84% {
    transform: translate(55.3104vw, 43.84vh) scale(0.73);
  }
  to {
    transform: translate(51.8199vw, 100vh) scale(0.73);
  }
}
.snow:nth-child(19) {
  opacity: 0.7026;
  transform: translate(0.1625vw, -10px) scale(0.1896);
  animation: fall-19 28s -29s linear infinite;
}
@keyframes fall-19 {
  78.945% {
    transform: translate(-5.9731vw, 78.945vh) scale(0.1896);
  }
  to {
    transform: translate(-2.9053vw, 100vh) scale(0.1896);
  }
}
.snow:nth-child(20) {
  opacity: 0.5229;
  transform: translate(33.1205vw, -10px) scale(0.1355);
  animation: fall-20 26s -16s linear infinite;
}
@keyframes fall-20 {
  39.665% {
    transform: translate(40.1017vw, 39.665vh) scale(0.1355);
  }
  to {
    transform: translate(36.6111vw, 100vh) scale(0.1355);
  }
}
.snow:nth-child(21) {
  opacity: 0.5274;
  transform: translate(0.7745vw, -10px) scale(0.9485);
  animation: fall-21 22s -19s linear infinite;
}
@keyframes fall-21 {
  72.148% {
    transform: translate(-6.0474vw, 72.148vh) scale(0.9485);
  }
  to {
    transform: translate(-2.63645vw, 100vh) scale(0.9485);
  }
}
.snow:nth-child(22) {
  opacity: 0.6649;
  transform: translate(81.1602vw, -10px) scale(0.3405);
  animation: fall-22 25s -30s linear infinite;
}
@keyframes fall-22 {
  32.516% {
    transform: translate(76.4962vw, 32.516vh) scale(0.3405);
  }
  to {
    transform: translate(78.8282vw, 100vh) scale(0.3405);
  }
}
.snow:nth-child(23) {
  opacity: 0.6534;
  transform: translate(74.4313vw, -10px) scale(0.1101);
  animation: fall-23 24s -24s linear infinite;
}
@keyframes fall-23 {
  76.738% {
    transform: translate(65.079vw, 76.738vh) scale(0.1101);
  }
  to {
    transform: translate(69.75515vw, 100vh) scale(0.1101);
  }
}
.snow:nth-child(24) {
  opacity: 0.6608;
  transform: translate(17.1372vw, -10px) scale(0.2208);
  animation: fall-24 10s -27s linear infinite;
}
@keyframes fall-24 {
  76.093% {
    transform: translate(21.2059vw, 76.093vh) scale(0.2208);
  }
  to {
    transform: translate(19.17155vw, 100vh) scale(0.2208);
  }
}
.snow:nth-child(25) {
  opacity: 0.7526;
  transform: translate(40.497vw, -10px) scale(0.5226);
  animation: fall-25 18s -13s linear infinite;
}
@keyframes fall-25 {
  58.823% {
    transform: translate(48.9832vw, 58.823vh) scale(0.5226);
  }
  to {
    transform: translate(44.7401vw, 100vh) scale(0.5226);
  }
}
.snow:nth-child(26) {
  opacity: 0.4174;
  transform: translate(15.4128vw, -10px) scale(0.3232);
  animation: fall-26 30s -11s linear infinite;
}
@keyframes fall-26 {
  39.928% {
    transform: translate(24.7289vw, 39.928vh) scale(0.3232);
  }
  to {
    transform: translate(20.07085vw, 100vh) scale(0.3232);
  }
}
.snow:nth-child(27) {
  opacity: 0.5514;
  transform: translate(87.6652vw, -10px) scale(0.1676);
  animation: fall-27 29s -10s linear infinite;
}
@keyframes fall-27 {
  32.964% {
    transform: translate(87.1403vw, 32.964vh) scale(0.1676);
  }
  to {
    transform: translate(87.40275vw, 100vh) scale(0.1676);
  }
}
.snow:nth-child(28) {
  opacity: 0.2868;
  transform: translate(76.5754vw, -10px) scale(0.2299);
  animation: fall-28 15s -9s linear infinite;
}
@keyframes fall-28 {
  41.803% {
    transform: translate(83.0236vw, 41.803vh) scale(0.2299);
  }
  to {
    transform: translate(79.7995vw, 100vh) scale(0.2299);
  }
}
.snow:nth-child(29) {
  opacity: 0.4207;
  transform: translate(77.9348vw, -10px) scale(0.0123);
  animation: fall-29 24s -9s linear infinite;
}
@keyframes fall-29 {
  59.302% {
    transform: translate(84.5857vw, 59.302vh) scale(0.0123);
  }
  to {
    transform: translate(81.26025vw, 100vh) scale(0.0123);
  }
}
.snow:nth-child(30) {
  opacity: 0.9003;
  transform: translate(77.4907vw, -10px) scale(0.598);
  animation: fall-30 13s -20s linear infinite;
}
@keyframes fall-30 {
  49.666% {
    transform: translate(70.2097vw, 49.666vh) scale(0.598);
  }
  to {
    transform: translate(73.8502vw, 100vh) scale(0.598);
  }
}
.snow:nth-child(31) {
  opacity: 0.1053;
  transform: translate(75.4153vw, -10px) scale(0.7839);
  animation: fall-31 22s -17s linear infinite;
}
@keyframes fall-31 {
  70.386% {
    transform: translate(75.3726vw, 70.386vh) scale(0.7839);
  }
  to {
    transform: translate(75.39395vw, 100vh) scale(0.7839);
  }
}
.snow:nth-child(32) {
  opacity: 0.6446;
  transform: translate(64.3944vw, -10px) scale(0.6384);
  animation: fall-32 14s -5s linear infinite;
}
@keyframes fall-32 {
  38.542% {
    transform: translate(63.2438vw, 38.542vh) scale(0.6384);
  }
  to {
    transform: translate(63.8191vw, 100vh) scale(0.6384);
  }
}
.snow:nth-child(33) {
  opacity: 0.1009;
  transform: translate(69.5289vw, -10px) scale(0.2024);
  animation: fall-33 14s -21s linear infinite;
}
@keyframes fall-33 {
  42.229% {
    transform: translate(60.3872vw, 42.229vh) scale(0.2024);
  }
  to {
    transform: translate(64.95805vw, 100vh) scale(0.2024);
  }
}
.snow:nth-child(34) {
  opacity: 0.2624;
  transform: translate(18.0131vw, -10px) scale(0.4788);
  animation: fall-34 11s -6s linear infinite;
}
@keyframes fall-34 {
  56.085% {
    transform: translate(9.8259vw, 56.085vh) scale(0.4788);
  }
  to {
    transform: translate(13.9195vw, 100vh) scale(0.4788);
  }
}
.snow:nth-child(35) {
  opacity: 0.3757;
  transform: translate(62.6838vw, -10px) scale(0.2258);
  animation: fall-35 22s -24s linear infinite;
}
@keyframes fall-35 {
  64.342% {
    transform: translate(59.4411vw, 64.342vh) scale(0.2258);
  }
  to {
    transform: translate(61.06245vw, 100vh) scale(0.2258);
  }
}
.snow:nth-child(36) {
  opacity: 0.5175;
  transform: translate(52.9605vw, -10px) scale(0.8428);
  animation: fall-36 21s -30s linear infinite;
}
@keyframes fall-36 {
  48.044% {
    transform: translate(46.4815vw, 48.044vh) scale(0.8428);
  }
  to {
    transform: translate(49.721vw, 100vh) scale(0.8428);
  }
}
.snow:nth-child(37) {
  opacity: 0.36;
  transform: translate(40.078vw, -10px) scale(0.6205);
  animation: fall-37 16s -17s linear infinite;
}
@keyframes fall-37 {
  70.18% {
    transform: translate(46.1813vw, 70.18vh) scale(0.6205);
  }
  to {
    transform: translate(43.12965vw, 100vh) scale(0.6205);
  }
}
.snow:nth-child(38) {
  opacity: 0.07;
  transform: translate(55.7904vw, -10px) scale(0.9309);
  animation: fall-38 29s -7s linear infinite;
}
@keyframes fall-38 {
  49.684% {
    transform: translate(52.8048vw, 49.684vh) scale(0.9309);
  }
  to {
    transform: translate(54.2976vw, 100vh) scale(0.9309);
  }
}
.snow:nth-child(39) {
  opacity: 0.4107;
  transform: translate(79.4385vw, -10px) scale(0.2305);
  animation: fall-39 21s -19s linear infinite;
}
@keyframes fall-39 {
  56.676% {
    transform: translate(70.0019vw, 56.676vh) scale(0.2305);
  }
  to {
    transform: translate(74.7202vw, 100vh) scale(0.2305);
  }
}
.snow:nth-child(40) {
  opacity: 0.6008;
  transform: translate(7.0176vw, -10px) scale(0.3953);
  animation: fall-40 19s -3s linear infinite;
}
@keyframes fall-40 {
  71.198% {
    transform: translate(16.2742vw, 71.198vh) scale(0.3953);
  }
  to {
    transform: translate(11.6459vw, 100vh) scale(0.3953);
  }
}
.snow:nth-child(41) {
  opacity: 0.1967;
  transform: translate(31.8071vw, -10px) scale(0.918);
  animation: fall-41 12s -8s linear infinite;
}
@keyframes fall-41 {
  60.004% {
    transform: translate(37.6355vw, 60.004vh) scale(0.918);
  }
  to {
    transform: translate(34.7213vw, 100vh) scale(0.918);
  }
}
.snow:nth-child(42) {
  opacity: 0.1563;
  transform: translate(79.0642vw, -10px) scale(0.8343);
  animation: fall-42 29s -30s linear infinite;
}
@keyframes fall-42 {
  69.94% {
    transform: translate(85.849vw, 69.94vh) scale(0.8343);
  }
  to {
    transform: translate(82.4566vw, 100vh) scale(0.8343);
  }
}
.snow:nth-child(43) {
  opacity: 0.5814;
  transform: translate(97.3519vw, -10px) scale(0.4408);
  animation: fall-43 20s -8s linear infinite;
}
@keyframes fall-43 {
  64.617% {
    transform: translate(88.8361vw, 64.617vh) scale(0.4408);
  }
  to {
    transform: translate(93.094vw, 100vh) scale(0.4408);
  }
}
.snow:nth-child(44) {
  opacity: 0.4938;
  transform: translate(98.7969vw, -10px) scale(0.1795);
  animation: fall-44 18s -29s linear infinite;
}
@keyframes fall-44 {
  33.87% {
    transform: translate(98.0879vw, 33.87vh) scale(0.1795);
  }
  to {
    transform: translate(98.4424vw, 100vh) scale(0.1795);
  }
}
.snow:nth-child(45) {
  opacity: 0.053;
  transform: translate(19.0074vw, -10px) scale(0.7173);
  animation: fall-45 26s -15s linear infinite;
}
@keyframes fall-45 {
  68.238% {
    transform: translate(24.835vw, 68.238vh) scale(0.7173);
  }
  to {
    transform: translate(21.9212vw, 100vh) scale(0.7173);
  }
}
.snow:nth-child(46) {
  opacity: 0.2366;
  transform: translate(42.1226vw, -10px) scale(0.1364);
  animation: fall-46 16s -2s linear infinite;
}
@keyframes fall-46 {
  40.685% {
    transform: translate(45.0828vw, 40.685vh) scale(0.1364);
  }
  to {
    transform: translate(43.6027vw, 100vh) scale(0.1364);
  }
}
.snow:nth-child(47) {
  opacity: 0.7876;
  transform: translate(12.3727vw, -10px) scale(0.8425);
  animation: fall-47 30s -11s linear infinite;
}
@keyframes fall-47 {
  45.281% {
    transform: translate(3.1796vw, 45.281vh) scale(0.8425);
  }
  to {
    transform: translate(7.77615vw, 100vh) scale(0.8425);
  }
}
.snow:nth-child(48) {
  opacity: 0.1927;
  transform: translate(99.1602vw, -10px) scale(0.6155);
  animation: fall-48 17s -27s linear infinite;
}
@keyframes fall-48 {
  66.508% {
    transform: translate(103.7665vw, 66.508vh) scale(0.6155);
  }
  to {
    transform: translate(101.46335vw, 100vh) scale(0.6155);
  }
}
.snow:nth-child(49) {
  opacity: 0.9195;
  transform: translate(67.6785vw, -10px) scale(0.1491);
  animation: fall-49 18s -1s linear infinite;
}
@keyframes fall-49 {
  47.341% {
    transform: translate(67.825vw, 47.341vh) scale(0.1491);
  }
  to {
    transform: translate(67.75175vw, 100vh) scale(0.1491);
  }
}
.snow:nth-child(50) {
  opacity: 0.9258;
  transform: translate(18.2366vw, -10px) scale(0.0548);
  animation: fall-50 14s -15s linear infinite;
}
@keyframes fall-50 {
  69.351% {
    transform: translate(13.0036vw, 69.351vh) scale(0.0548);
  }
  to {
    transform: translate(15.6201vw, 100vh) scale(0.0548);
  }
}
.snow:nth-child(51) {
  opacity: 0.8684;
  transform: translate(83.2595vw, -10px) scale(0.3595);
  animation: fall-51 30s -7s linear infinite;
}
@keyframes fall-51 {
  50.744% {
    transform: translate(86.8456vw, 50.744vh) scale(0.3595);
  }
  to {
    transform: translate(85.05255vw, 100vh) scale(0.3595);
  }
}
.snow:nth-child(52) {
  opacity: 0.7826;
  transform: translate(79.9912vw, -10px) scale(0.3535);
  animation: fall-52 12s -29s linear infinite;
}
@keyframes fall-52 {
  76.512% {
    transform: translate(84.3926vw, 76.512vh) scale(0.3535);
  }
  to {
    transform: translate(82.1919vw, 100vh) scale(0.3535);
  }
}
.snow:nth-child(53) {
  opacity: 0.9773;
  transform: translate(21.468vw, -10px) scale(0.007);
  animation: fall-53 14s -11s linear infinite;
}
@keyframes fall-53 {
  68.21% {
    transform: translate(12.1757vw, 68.21vh) scale(0.007);
  }
  to {
    transform: translate(16.82185vw, 100vh) scale(0.007);
  }
}
.snow:nth-child(54) {
  opacity: 0.8161;
  transform: translate(90.1867vw, -10px) scale(0.848);
  animation: fall-54 11s -1s linear infinite;
}
@keyframes fall-54 {
  76.869% {
    transform: translate(84.4286vw, 76.869vh) scale(0.848);
  }
  to {
    transform: translate(87.30765vw, 100vh) scale(0.848);
  }
}
.snow:nth-child(55) {
  opacity: 0.0823;
  transform: translate(68.4717vw, -10px) scale(0.4747);
  animation: fall-55 15s -3s linear infinite;
}
@keyframes fall-55 {
  37.881% {
    transform: translate(67.7358vw, 37.881vh) scale(0.4747);
  }
  to {
    transform: translate(68.10375vw, 100vh) scale(0.4747);
  }
}
.snow:nth-child(56) {
  opacity: 0.6308;
  transform: translate(68.6765vw, -10px) scale(0.5152);
  animation: fall-56 28s -14s linear infinite;
}
@keyframes fall-56 {
  54.48% {
    transform: translate(60.7777vw, 54.48vh) scale(0.5152);
  }
  to {
    transform: translate(64.7271vw, 100vh) scale(0.5152);
  }
}
.snow:nth-child(57) {
  opacity: 0.8626;
  transform: translate(9.1594vw, -10px) scale(0.5147);
  animation: fall-57 23s -12s linear infinite;
}
@keyframes fall-57 {
  55.113% {
    transform: translate(13.3787vw, 55.113vh) scale(0.5147);
  }
  to {
    transform: translate(11.26905vw, 100vh) scale(0.5147);
  }
}
.snow:nth-child(58) {
  opacity: 0.3413;
  transform: translate(16.7606vw, -10px) scale(0.1173);
  animation: fall-58 12s -12s linear infinite;
}
@keyframes fall-58 {
  33.787% {
    transform: translate(12.7402vw, 33.787vh) scale(0.1173);
  }
  to {
    transform: translate(14.7504vw, 100vh) scale(0.1173);
  }
}
.snow:nth-child(59) {
  opacity: 0.9369;
  transform: translate(3.9786vw, -10px) scale(0.6511);
  animation: fall-59 10s -24s linear infinite;
}
@keyframes fall-59 {
  63.042% {
    transform: translate(4.252vw, 63.042vh) scale(0.6511);
  }
  to {
    transform: translate(4.1153vw, 100vh) scale(0.6511);
  }
}
.snow:nth-child(60) {
  opacity: 0.325;
  transform: translate(67.2817vw, -10px) scale(0.2868);
  animation: fall-60 15s -17s linear infinite;
}
@keyframes fall-60 {
  72.756% {
    transform: translate(72.8119vw, 72.756vh) scale(0.2868);
  }
  to {
    transform: translate(70.0468vw, 100vh) scale(0.2868);
  }
}
.snow:nth-child(61) {
  opacity: 0.8968;
  transform: translate(5.166vw, -10px) scale(0.3163);
  animation: fall-61 12s -10s linear infinite;
}
@keyframes fall-61 {
  37.264% {
    transform: translate(8.4479vw, 37.264vh) scale(0.3163);
  }
  to {
    transform: translate(6.80695vw, 100vh) scale(0.3163);
  }
}
.snow:nth-child(62) {
  opacity: 0.4947;
  transform: translate(93.4794vw, -10px) scale(0.0256);
  animation: fall-62 12s -11s linear infinite;
}
@keyframes fall-62 {
  79.905% {
    transform: translate(92.2522vw, 79.905vh) scale(0.0256);
  }
  to {
    transform: translate(92.8658vw, 100vh) scale(0.0256);
  }
}
.snow:nth-child(63) {
  opacity: 0.7738;
  transform: translate(29.8174vw, -10px) scale(0.3259);
  animation: fall-63 27s -14s linear infinite;
}
@keyframes fall-63 {
  66.162% {
    transform: translate(35.6844vw, 66.162vh) scale(0.3259);
  }
  to {
    transform: translate(32.7509vw, 100vh) scale(0.3259);
  }
}
.snow:nth-child(64) {
  opacity: 0.1844;
  transform: translate(0.788vw, -10px) scale(0.6816);
  animation: fall-64 29s -18s linear infinite;
}
@keyframes fall-64 {
  53.376% {
    transform: translate(-6.3511vw, 53.376vh) scale(0.6816);
  }
  to {
    transform: translate(-2.78155vw, 100vh) scale(0.6816);
  }
}
.snow:nth-child(65) {
  opacity: 0.7758;
  transform: translate(45.8888vw, -10px) scale(0.6572);
  animation: fall-65 17s -21s linear infinite;
}
@keyframes fall-65 {
  50.505% {
    transform: translate(51.6579vw, 50.505vh) scale(0.6572);
  }
  to {
    transform: translate(48.77335vw, 100vh) scale(0.6572);
  }
}
.snow:nth-child(66) {
  opacity: 0.2064;
  transform: translate(10.2038vw, -10px) scale(0.3953);
  animation: fall-66 28s -10s linear infinite;
}
@keyframes fall-66 {
  36.86% {
    transform: translate(17.2521vw, 36.86vh) scale(0.3953);
  }
  to {
    transform: translate(13.72795vw, 100vh) scale(0.3953);
  }
}
.snow:nth-child(67) {
  opacity: 0.9207;
  transform: translate(61.8923vw, -10px) scale(0.577);
  animation: fall-67 20s -11s linear infinite;
}
@keyframes fall-67 {
  67.671% {
    transform: translate(53.9949vw, 67.671vh) scale(0.577);
  }
  to {
    transform: translate(57.9436vw, 100vh) scale(0.577);
  }
}
.snow:nth-child(68) {
  opacity: 0.5591;
  transform: translate(76.4941vw, -10px) scale(0.7445);
  animation: fall-68 27s -6s linear infinite;
}
@keyframes fall-68 {
  31.894% {
    transform: translate(71.9607vw, 31.894vh) scale(0.7445);
  }
  to {
    transform: translate(74.2274vw, 100vh) scale(0.7445);
  }
}
.snow:nth-child(69) {
  opacity: 0.8199;
  transform: translate(12.2342vw, -10px) scale(0.0821);
  animation: fall-69 27s -17s linear infinite;
}
@keyframes fall-69 {
  48.605% {
    transform: translate(21.6432vw, 48.605vh) scale(0.0821);
  }
  to {
    transform: translate(16.9387vw, 100vh) scale(0.0821);
  }
}
.snow:nth-child(70) {
  opacity: 0.0016;
  transform: translate(90.4596vw, -10px) scale(0.1203);
  animation: fall-70 23s -24s linear infinite;
}
@keyframes fall-70 {
  36.506% {
    transform: translate(85.693vw, 36.506vh) scale(0.1203);
  }
  to {
    transform: translate(88.0763vw, 100vh) scale(0.1203);
  }
}
.snow:nth-child(71) {
  opacity: 0.5845;
  transform: translate(64.5624vw, -10px) scale(0.6527);
  animation: fall-71 27s -15s linear infinite;
}
@keyframes fall-71 {
  35.238% {
    transform: translate(74.2701vw, 35.238vh) scale(0.6527);
  }
  to {
    transform: translate(69.41625vw, 100vh) scale(0.6527);
  }
}
.snow:nth-child(72) {
  opacity: 0.111;
  transform: translate(23.8221vw, -10px) scale(0.0566);
  animation: fall-72 24s -11s linear infinite;
}
@keyframes fall-72 {
  34.838% {
    transform: translate(29.5569vw, 34.838vh) scale(0.0566);
  }
  to {
    transform: translate(26.6895vw, 100vh) scale(0.0566);
  }
}
.snow:nth-child(73) {
  opacity: 0.0168;
  transform: translate(62.9296vw, -10px) scale(0.0409);
  animation: fall-73 15s -15s linear infinite;
}
@keyframes fall-73 {
  61.038% {
    transform: translate(61.842vw, 61.038vh) scale(0.0409);
  }
  to {
    transform: translate(62.3858vw, 100vh) scale(0.0409);
  }
}
.snow:nth-child(74) {
  opacity: 0.6892;
  transform: translate(87.0394vw, -10px) scale(0.7169);
  animation: fall-74 30s -29s linear infinite;
}
@keyframes fall-74 {
  74.16% {
    transform: translate(79.0359vw, 74.16vh) scale(0.7169);
  }
  to {
    transform: translate(83.03765vw, 100vh) scale(0.7169);
  }
}
.snow:nth-child(75) {
  opacity: 0.7258;
  transform: translate(23.7666vw, -10px) scale(0.9835);
  animation: fall-75 24s -23s linear infinite;
}
@keyframes fall-75 {
  61.969% {
    transform: translate(15.3355vw, 61.969vh) scale(0.9835);
  }
  to {
    transform: translate(19.55105vw, 100vh) scale(0.9835);
  }
}
.snow:nth-child(76) {
  opacity: 0.8836;
  transform: translate(62.4264vw, -10px) scale(0.2835);
  animation: fall-76 19s -2s linear infinite;
}
@keyframes fall-76 {
  57.159% {
    transform: translate(60.1017vw, 57.159vh) scale(0.2835);
  }
  to {
    transform: translate(61.26405vw, 100vh) scale(0.2835);
  }
}
.snow:nth-child(77) {
  opacity: 0.4828;
  transform: translate(59.2554vw, -10px) scale(0.7873);
  animation: fall-77 19s -30s linear infinite;
}
@keyframes fall-77 {
  55.942% {
    transform: translate(50.8315vw, 55.942vh) scale(0.7873);
  }
  to {
    transform: translate(55.04345vw, 100vh) scale(0.7873);
  }
}
.snow:nth-child(78) {
  opacity: 0.8451;
  transform: translate(40.7165vw, -10px) scale(0.9513);
  animation: fall-78 15s -3s linear infinite;
}
@keyframes fall-78 {
  53.868% {
    transform: translate(44.1191vw, 53.868vh) scale(0.9513);
  }
  to {
    transform: translate(42.4178vw, 100vh) scale(0.9513);
  }
}
.snow:nth-child(79) {
  opacity: 0.8235;
  transform: translate(35.275vw, -10px) scale(0.9499);
  animation: fall-79 27s -12s linear infinite;
}
@keyframes fall-79 {
  68.444% {
    transform: translate(43.9222vw, 68.444vh) scale(0.9499);
  }
  to {
    transform: translate(39.5986vw, 100vh) scale(0.9499);
  }
}
.snow:nth-child(80) {
  opacity: 0.5056;
  transform: translate(83.5199vw, -10px) scale(0.9604);
  animation: fall-80 26s -11s linear infinite;
}
@keyframes fall-80 {
  67.931% {
    transform: translate(89.9139vw, 67.931vh) scale(0.9604);
  }
  to {
    transform: translate(86.7169vw, 100vh) scale(0.9604);
  }
}
.snow:nth-child(81) {
  opacity: 0.4408;
  transform: translate(6.085vw, -10px) scale(0.0188);
  animation: fall-81 19s -30s linear infinite;
}
@keyframes fall-81 {
  57.486% {
    transform: translate(-1.1133vw, 57.486vh) scale(0.0188);
  }
  to {
    transform: translate(2.48585vw, 100vh) scale(0.0188);
  }
}
.snow:nth-child(82) {
  opacity: 0.3075;
  transform: translate(44.4308vw, -10px) scale(0.7335);
  animation: fall-82 30s -28s linear infinite;
}
@keyframes fall-82 {
  50.595% {
    transform: translate(38.506vw, 50.595vh) scale(0.7335);
  }
  to {
    transform: translate(41.4684vw, 100vh) scale(0.7335);
  }
}
.snow:nth-child(83) {
  opacity: 0.9375;
  transform: translate(82.7714vw, -10px) scale(0.1477);
  animation: fall-83 11s -18s linear infinite;
}
@keyframes fall-83 {
  32.907% {
    transform: translate(91.8153vw, 32.907vh) scale(0.1477);
  }
  to {
    transform: translate(87.29335vw, 100vh) scale(0.1477);
  }
}
.snow:nth-child(84) {
  opacity: 0.1985;
  transform: translate(95.7283vw, -10px) scale(0.6091);
  animation: fall-84 30s -1s linear infinite;
}
@keyframes fall-84 {
  37.107% {
    transform: translate(104.7365vw, 37.107vh) scale(0.6091);
  }
  to {
    transform: translate(100.2324vw, 100vh) scale(0.6091);
  }
}
.snow:nth-child(85) {
  opacity: 0.6446;
  transform: translate(45.7253vw, -10px) scale(0.7896);
  animation: fall-85 27s -15s linear infinite;
}
@keyframes fall-85 {
  35.185% {
    transform: translate(54.5611vw, 35.185vh) scale(0.7896);
  }
  to {
    transform: translate(50.1432vw, 100vh) scale(0.7896);
  }
}
.snow:nth-child(86) {
  opacity: 0.5882;
  transform: translate(72.0936vw, -10px) scale(0.4088);
  animation: fall-86 18s -19s linear infinite;
}
@keyframes fall-86 {
  71.047% {
    transform: translate(72.3733vw, 71.047vh) scale(0.4088);
  }
  to {
    transform: translate(72.23345vw, 100vh) scale(0.4088);
  }
}
.snow:nth-child(87) {
  opacity: 0.1413;
  transform: translate(90.7834vw, -10px) scale(0.1143);
  animation: fall-87 27s -2s linear infinite;
}
@keyframes fall-87 {
  74.436% {
    transform: translate(82.0448vw, 74.436vh) scale(0.1143);
  }
  to {
    transform: translate(86.4141vw, 100vh) scale(0.1143);
  }
}
.snow:nth-child(88) {
  opacity: 0.6812;
  transform: translate(63.464vw, -10px) scale(0.1036);
  animation: fall-88 23s -28s linear infinite;
}
@keyframes fall-88 {
  65.714% {
    transform: translate(64.4918vw, 65.714vh) scale(0.1036);
  }
  to {
    transform: translate(63.9779vw, 100vh) scale(0.1036);
  }
}
.snow:nth-child(89) {
  opacity: 0.8445;
  transform: translate(27.2456vw, -10px) scale(0.1414);
  animation: fall-89 15s -24s linear infinite;
}
@keyframes fall-89 {
  39.668% {
    transform: translate(23.6844vw, 39.668vh) scale(0.1414);
  }
  to {
    transform: translate(25.465vw, 100vh) scale(0.1414);
  }
}
.snow:nth-child(90) {
  opacity: 0.6727;
  transform: translate(44.9263vw, -10px) scale(0.9736);
  animation: fall-90 24s -10s linear infinite;
}
@keyframes fall-90 {
  74.753% {
    transform: translate(35.1569vw, 74.753vh) scale(0.9736);
  }
  to {
    transform: translate(40.0416vw, 100vh) scale(0.9736);
  }
}
.snow:nth-child(91) {
  opacity: 0.4842;
  transform: translate(29.737vw, -10px) scale(0.356);
  animation: fall-91 21s -10s linear infinite;
}
@keyframes fall-91 {
  42.897% {
    transform: translate(23.0515vw, 42.897vh) scale(0.356);
  }
  to {
    transform: translate(26.39425vw, 100vh) scale(0.356);
  }
}
.snow:nth-child(92) {
  opacity: 0.3825;
  transform: translate(91.5276vw, -10px) scale(0.9722);
  animation: fall-92 11s -12s linear infinite;
}
@keyframes fall-92 {
  70.213% {
    transform: translate(94.5399vw, 70.213vh) scale(0.9722);
  }
  to {
    transform: translate(93.03375vw, 100vh) scale(0.9722);
  }
}
.snow:nth-child(93) {
  opacity: 0.8305;
  transform: translate(84.2656vw, -10px) scale(0.6629);
  animation: fall-93 22s -14s linear infinite;
}
@keyframes fall-93 {
  42.005% {
    transform: translate(77.3548vw, 42.005vh) scale(0.6629);
  }
  to {
    transform: translate(80.8102vw, 100vh) scale(0.6629);
  }
}
.snow:nth-child(94) {
  opacity: 0.5878;
  transform: translate(95.7054vw, -10px) scale(0.5);
  animation: fall-94 16s -24s linear infinite;
}
@keyframes fall-94 {
  63.789% {
    transform: translate(100.3691vw, 63.789vh) scale(0.5);
  }
  to {
    transform: translate(98.03725vw, 100vh) scale(0.5);
  }
}
.snow:nth-child(95) {
  opacity: 0.8116;
  transform: translate(35.9808vw, -10px) scale(0.3112);
  animation: fall-95 18s -7s linear infinite;
}
@keyframes fall-95 {
  60.431% {
    transform: translate(43.5294vw, 60.431vh) scale(0.3112);
  }
  to {
    transform: translate(39.7551vw, 100vh) scale(0.3112);
  }
}
.snow:nth-child(96) {
  opacity: 0.4165;
  transform: translate(72.2622vw, -10px) scale(0.2456);
  animation: fall-96 18s -25s linear infinite;
}
@keyframes fall-96 {
  76.372% {
    transform: translate(76.7168vw, 76.372vh) scale(0.2456);
  }
  to {
    transform: translate(74.4895vw, 100vh) scale(0.2456);
  }
}
.snow:nth-child(97) {
  opacity: 0.1257;
  transform: translate(95.4186vw, -10px) scale(0.8859);
  animation: fall-97 17s -3s linear infinite;
}
@keyframes fall-97 {
  56.383% {
    transform: translate(104.7606vw, 56.383vh) scale(0.8859);
  }
  to {
    transform: translate(100.0896vw, 100vh) scale(0.8859);
  }
}
.snow:nth-child(98) {
  opacity: 0.3618;
  transform: translate(20.2518vw, -10px) scale(0.0688);
  animation: fall-98 15s -15s linear infinite;
}
@keyframes fall-98 {
  36.032% {
    transform: translate(10.6994vw, 36.032vh) scale(0.0688);
  }
  to {
    transform: translate(15.4756vw, 100vh) scale(0.0688);
  }
}
.snow:nth-child(99) {
  opacity: 0.981;
  transform: translate(41.6463vw, -10px) scale(0.2679);
  animation: fall-99 27s -23s linear infinite;
}
@keyframes fall-99 {
  79.652% {
    transform: translate(32.5414vw, 79.652vh) scale(0.2679);
  }
  to {
    transform: translate(37.09385vw, 100vh) scale(0.2679);
  }
}
.snow:nth-child(100) {
  opacity: 0.5968;
  transform: translate(8.1671vw, -10px) scale(0.4264);
  animation: fall-100 12s -24s linear infinite;
}
@keyframes fall-100 {
  42.848% {
    transform: translate(15.5113vw, 42.848vh) scale(0.4264);
  }
  to {
    transform: translate(11.8392vw, 100vh) scale(0.4264);
  }
}
.snow:nth-child(101) {
  opacity: 0.862;
  transform: translate(75.1798vw, -10px) scale(0.8681);
  animation: fall-101 18s -12s linear infinite;
}
@keyframes fall-101 {
  69.276% {
    transform: translate(84.4599vw, 69.276vh) scale(0.8681);
  }
  to {
    transform: translate(79.81985vw, 100vh) scale(0.8681);
  }
}
.snow:nth-child(102) {
  opacity: 0.4873;
  transform: translate(8.3695vw, -10px) scale(0.3939);
  animation: fall-102 14s -6s linear infinite;
}
@keyframes fall-102 {
  32.226% {
    transform: translate(12.6715vw, 32.226vh) scale(0.3939);
  }
  to {
    transform: translate(10.5205vw, 100vh) scale(0.3939);
  }
}
.snow:nth-child(103) {
  opacity: 0.2798;
  transform: translate(39.3958vw, -10px) scale(0.5393);
  animation: fall-103 23s -1s linear infinite;
}
@keyframes fall-103 {
  52.54% {
    transform: translate(32.6041vw, 52.54vh) scale(0.5393);
  }
  to {
    transform: translate(35.99995vw, 100vh) scale(0.5393);
  }
}
.snow:nth-child(104) {
  opacity: 0.6752;
  transform: translate(22.729vw, -10px) scale(0.0558);
  animation: fall-104 19s -28s linear infinite;
}
@keyframes fall-104 {
  67.133% {
    transform: translate(30.3915vw, 67.133vh) scale(0.0558);
  }
  to {
    transform: translate(26.56025vw, 100vh) scale(0.0558);
  }
}
.snow:nth-child(105) {
  opacity: 0.466;
  transform: translate(68.4866vw, -10px) scale(0.1261);
  animation: fall-105 23s -29s linear infinite;
}
@keyframes fall-105 {
  76.831% {
    transform: translate(76.7575vw, 76.831vh) scale(0.1261);
  }
  to {
    transform: translate(72.62205vw, 100vh) scale(0.1261);
  }
}
.snow:nth-child(106) {
  opacity: 0.972;
  transform: translate(18.1669vw, -10px) scale(0.3035);
  animation: fall-106 10s -7s linear infinite;
}
@keyframes fall-106 {
  63.71% {
    transform: translate(8.5948vw, 63.71vh) scale(0.3035);
  }
  to {
    transform: translate(13.38085vw, 100vh) scale(0.3035);
  }
}
.snow:nth-child(107) {
  opacity: 0.5685;
  transform: translate(12.2244vw, -10px) scale(0.8892);
  animation: fall-107 24s -4s linear infinite;
}
@keyframes fall-107 {
  58.959% {
    transform: translate(7.7809vw, 58.959vh) scale(0.8892);
  }
  to {
    transform: translate(10.00265vw, 100vh) scale(0.8892);
  }
}
.snow:nth-child(108) {
  opacity: 0.442;
  transform: translate(86.6286vw, -10px) scale(0.5664);
  animation: fall-108 26s -18s linear infinite;
}
@keyframes fall-108 {
  57.898% {
    transform: translate(91.8687vw, 57.898vh) scale(0.5664);
  }
  to {
    transform: translate(89.24865vw, 100vh) scale(0.5664);
  }
}
.snow:nth-child(109) {
  opacity: 0.8989;
  transform: translate(77.2451vw, -10px) scale(0.5778);
  animation: fall-109 12s -30s linear infinite;
}
@keyframes fall-109 {
  36.293% {
    transform: translate(81.1455vw, 36.293vh) scale(0.5778);
  }
  to {
    transform: translate(79.1953vw, 100vh) scale(0.5778);
  }
}
.snow:nth-child(110) {
  opacity: 0.3372;
  transform: translate(43.5731vw, -10px) scale(0.3554);
  animation: fall-110 13s -2s linear infinite;
}
@keyframes fall-110 {
  60.514% {
    transform: translate(45.9245vw, 60.514vh) scale(0.3554);
  }
  to {
    transform: translate(44.7488vw, 100vh) scale(0.3554);
  }
}
.snow:nth-child(111) {
  opacity: 0.1028;
  transform: translate(32.3754vw, -10px) scale(0.1534);
  animation: fall-111 28s -19s linear infinite;
}
@keyframes fall-111 {
  49.298% {
    transform: translate(33.0832vw, 49.298vh) scale(0.1534);
  }
  to {
    transform: translate(32.7293vw, 100vh) scale(0.1534);
  }
}
.snow:nth-child(112) {
  opacity: 0.3175;
  transform: translate(71.1231vw, -10px) scale(0.734);
  animation: fall-112 22s -7s linear infinite;
}
@keyframes fall-112 {
  75.771% {
    transform: translate(66.6258vw, 75.771vh) scale(0.734);
  }
  to {
    transform: translate(68.87445vw, 100vh) scale(0.734);
  }
}
.snow:nth-child(113) {
  opacity: 0.0137;
  transform: translate(46.4245vw, -10px) scale(0.86);
  animation: fall-113 26s -4s linear infinite;
}
@keyframes fall-113 {
  33.434% {
    transform: translate(47.4795vw, 33.434vh) scale(0.86);
  }
  to {
    transform: translate(46.952vw, 100vh) scale(0.86);
  }
}
.snow:nth-child(114) {
  opacity: 0.0548;
  transform: translate(84.9913vw, -10px) scale(0.9506);
  animation: fall-114 19s -2s linear infinite;
}
@keyframes fall-114 {
  45.858% {
    transform: translate(93.1963vw, 45.858vh) scale(0.9506);
  }
  to {
    transform: translate(89.0938vw, 100vh) scale(0.9506);
  }
}
.snow:nth-child(115) {
  opacity: 0.178;
  transform: translate(53.3116vw, -10px) scale(0.3249);
  animation: fall-115 30s -10s linear infinite;
}
@keyframes fall-115 {
  30.566% {
    transform: translate(57.5898vw, 30.566vh) scale(0.3249);
  }
  to {
    transform: translate(55.4507vw, 100vh) scale(0.3249);
  }
}
.snow:nth-child(116) {
  opacity: 0.2143;
  transform: translate(87.6864vw, -10px) scale(0.9716);
  animation: fall-116 26s -29s linear infinite;
}
@keyframes fall-116 {
  33.053% {
    transform: translate(79.7736vw, 33.053vh) scale(0.9716);
  }
  to {
    transform: translate(83.73vw, 100vh) scale(0.9716);
  }
}
.snow:nth-child(117) {
  opacity: 0.6285;
  transform: translate(26.8312vw, -10px) scale(0.1524);
  animation: fall-117 20s -18s linear infinite;
}
@keyframes fall-117 {
  49.986% {
    transform: translate(36.191vw, 49.986vh) scale(0.1524);
  }
  to {
    transform: translate(31.5111vw, 100vh) scale(0.1524);
  }
}
.snow:nth-child(118) {
  opacity: 0.2595;
  transform: translate(88.2862vw, -10px) scale(0.7888);
  animation: fall-118 14s -23s linear infinite;
}
@keyframes fall-118 {
  63.721% {
    transform: translate(84.0148vw, 63.721vh) scale(0.7888);
  }
  to {
    transform: translate(86.1505vw, 100vh) scale(0.7888);
  }
}
.snow:nth-child(119) {
  opacity: 0.0528;
  transform: translate(10.286vw, -10px) scale(0.164);
  animation: fall-119 22s -5s linear infinite;
}
@keyframes fall-119 {
  34.377% {
    transform: translate(11.1691vw, 34.377vh) scale(0.164);
  }
  to {
    transform: translate(10.72755vw, 100vh) scale(0.164);
  }
}
.snow:nth-child(120) {
  opacity: 0.6085;
  transform: translate(68.1997vw, -10px) scale(0.337);
  animation: fall-120 17s -15s linear infinite;
}
@keyframes fall-120 {
  69.988% {
    transform: translate(60.718vw, 69.988vh) scale(0.337);
  }
  to {
    transform: translate(64.45885vw, 100vh) scale(0.337);
  }
}
.snow:nth-child(121) {
  opacity: 0.6005;
  transform: translate(30.3927vw, -10px) scale(0.0337);
  animation: fall-121 21s -24s linear infinite;
}
@keyframes fall-121 {
  47.397% {
    transform: translate(29.8344vw, 47.397vh) scale(0.0337);
  }
  to {
    transform: translate(30.11355vw, 100vh) scale(0.0337);
  }
}
.snow:nth-child(122) {
  opacity: 0.3479;
  transform: translate(70.2952vw, -10px) scale(0.1218);
  animation: fall-122 22s -10s linear infinite;
}
@keyframes fall-122 {
  42.193% {
    transform: translate(73.2377vw, 42.193vh) scale(0.1218);
  }
  to {
    transform: translate(71.76645vw, 100vh) scale(0.1218);
  }
}
.snow:nth-child(123) {
  opacity: 0.5971;
  transform: translate(78.9987vw, -10px) scale(0.541);
  animation: fall-123 28s -3s linear infinite;
}
@keyframes fall-123 {
  70.393% {
    transform: translate(72.6252vw, 70.393vh) scale(0.541);
  }
  to {
    transform: translate(75.81195vw, 100vh) scale(0.541);
  }
}
.snow:nth-child(124) {
  opacity: 0.2171;
  transform: translate(2.2464vw, -10px) scale(0.6205);
  animation: fall-124 12s -9s linear infinite;
}
@keyframes fall-124 {
  58.408% {
    transform: translate(9.6928vw, 58.408vh) scale(0.6205);
  }
  to {
    transform: translate(5.9696vw, 100vh) scale(0.6205);
  }
}
.snow:nth-child(125) {
  opacity: 0.9603;
  transform: translate(12.1693vw, -10px) scale(0.2508);
  animation: fall-125 12s -30s linear infinite;
}
@keyframes fall-125 {
  61.094% {
    transform: translate(13.7182vw, 61.094vh) scale(0.2508);
  }
  to {
    transform: translate(12.94375vw, 100vh) scale(0.2508);
  }
}
.snow:nth-child(126) {
  opacity: 0.4479;
  transform: translate(85.8439vw, -10px) scale(0.7602);
  animation: fall-126 16s -3s linear infinite;
}
@keyframes fall-126 {
  31.153% {
    transform: translate(80.3336vw, 31.153vh) scale(0.7602);
  }
  to {
    transform: translate(83.08875vw, 100vh) scale(0.7602);
  }
}
.snow:nth-child(127) {
  opacity: 0.8958;
  transform: translate(54.6392vw, -10px) scale(0.9426);
  animation: fall-127 11s -19s linear infinite;
}
@keyframes fall-127 {
  56.894% {
    transform: translate(51.8417vw, 56.894vh) scale(0.9426);
  }
  to {
    transform: translate(53.24045vw, 100vh) scale(0.9426);
  }
}
.snow:nth-child(128) {
  opacity: 0.2304;
  transform: translate(17.4955vw, -10px) scale(0.5455);
  animation: fall-128 14s -26s linear infinite;
}
@keyframes fall-128 {
  78.428% {
    transform: translate(19.8644vw, 78.428vh) scale(0.5455);
  }
  to {
    transform: translate(18.67995vw, 100vh) scale(0.5455);
  }
}
.snow:nth-child(129) {
  opacity: 0.4113;
  transform: translate(23.0304vw, -10px) scale(0.8924);
  animation: fall-129 17s -28s linear infinite;
}
@keyframes fall-129 {
  31.264% {
    transform: translate(19.9364vw, 31.264vh) scale(0.8924);
  }
  to {
    transform: translate(21.4834vw, 100vh) scale(0.8924);
  }
}
.snow:nth-child(130) {
  opacity: 0.6587;
  transform: translate(64.1174vw, -10px) scale(0.6248);
  animation: fall-130 25s -8s linear infinite;
}
@keyframes fall-130 {
  39.272% {
    transform: translate(63.4827vw, 39.272vh) scale(0.6248);
  }
  to {
    transform: translate(63.80005vw, 100vh) scale(0.6248);
  }
}
.snow:nth-child(131) {
  opacity: 0.9458;
  transform: translate(20.3569vw, -10px) scale(0.2573);
  animation: fall-131 29s -19s linear infinite;
}
@keyframes fall-131 {
  41.769% {
    transform: translate(12.7595vw, 41.769vh) scale(0.2573);
  }
  to {
    transform: translate(16.5582vw, 100vh) scale(0.2573);
  }
}
.snow:nth-child(132) {
  opacity: 0.6834;
  transform: translate(9.3006vw, -10px) scale(0.9219);
  animation: fall-132 29s -2s linear infinite;
}
@keyframes fall-132 {
  50.081% {
    transform: translate(19.0197vw, 50.081vh) scale(0.9219);
  }
  to {
    transform: translate(14.16015vw, 100vh) scale(0.9219);
  }
}
.snow:nth-child(133) {
  opacity: 0.2478;
  transform: translate(53.5892vw, -10px) scale(0.9434);
  animation: fall-133 14s -5s linear infinite;
}
@keyframes fall-133 {
  47.345% {
    transform: translate(47.1515vw, 47.345vh) scale(0.9434);
  }
  to {
    transform: translate(50.37035vw, 100vh) scale(0.9434);
  }
}
.snow:nth-child(134) {
  opacity: 0.3067;
  transform: translate(23.8526vw, -10px) scale(0.7808);
  animation: fall-134 17s -14s linear infinite;
}
@keyframes fall-134 {
  78.368% {
    transform: translate(14.5807vw, 78.368vh) scale(0.7808);
  }
  to {
    transform: translate(19.21665vw, 100vh) scale(0.7808);
  }
}
.snow:nth-child(135) {
  opacity: 0.5458;
  transform: translate(84.904vw, -10px) scale(0.1218);
  animation: fall-135 10s -18s linear infinite;
}
@keyframes fall-135 {
  64.629% {
    transform: translate(88.9419vw, 64.629vh) scale(0.1218);
  }
  to {
    transform: translate(86.92295vw, 100vh) scale(0.1218);
  }
}
.snow:nth-child(136) {
  opacity: 0.5521;
  transform: translate(83.6916vw, -10px) scale(0.0937);
  animation: fall-136 12s -14s linear infinite;
}
@keyframes fall-136 {
  54.485% {
    transform: translate(80.1609vw, 54.485vh) scale(0.0937);
  }
  to {
    transform: translate(81.92625vw, 100vh) scale(0.0937);
  }
}
.snow:nth-child(137) {
  opacity: 0.4825;
  transform: translate(22.4585vw, -10px) scale(0.5721);
  animation: fall-137 12s -23s linear infinite;
}
@keyframes fall-137 {
  64.096% {
    transform: translate(19.5218vw, 64.096vh) scale(0.5721);
  }
  to {
    transform: translate(20.99015vw, 100vh) scale(0.5721);
  }
}
.snow:nth-child(138) {
  opacity: 0.5423;
  transform: translate(82.7939vw, -10px) scale(0.6682);
  animation: fall-138 29s -14s linear infinite;
}
@keyframes fall-138 {
  31.242% {
    transform: translate(88.9525vw, 31.242vh) scale(0.6682);
  }
  to {
    transform: translate(85.8732vw, 100vh) scale(0.6682);
  }
}
.snow:nth-child(139) {
  opacity: 0.3243;
  transform: translate(44.9894vw, -10px) scale(0.5351);
  animation: fall-139 11s -24s linear infinite;
}
@keyframes fall-139 {
  73.956% {
    transform: translate(43.0922vw, 73.956vh) scale(0.5351);
  }
  to {
    transform: translate(44.0408vw, 100vh) scale(0.5351);
  }
}
.snow:nth-child(140) {
  opacity: 0.7346;
  transform: translate(85.0399vw, -10px) scale(0.8738);
  animation: fall-140 20s -22s linear infinite;
}
@keyframes fall-140 {
  34.029% {
    transform: translate(92.9611vw, 34.029vh) scale(0.8738);
  }
  to {
    transform: translate(89.0005vw, 100vh) scale(0.8738);
  }
}
.snow:nth-child(141) {
  opacity: 0.4532;
  transform: translate(94.5994vw, -10px) scale(0.4286);
  animation: fall-141 15s -8s linear infinite;
}
@keyframes fall-141 {
  59.934% {
    transform: translate(88.0645vw, 59.934vh) scale(0.4286);
  }
  to {
    transform: translate(91.33195vw, 100vh) scale(0.4286);
  }
}
.snow:nth-child(142) {
  opacity: 0.5953;
  transform: translate(25.0398vw, -10px) scale(0.9222);
  animation: fall-142 14s -26s linear infinite;
}
@keyframes fall-142 {
  30.103% {
    transform: translate(25.7457vw, 30.103vh) scale(0.9222);
  }
  to {
    transform: translate(25.39275vw, 100vh) scale(0.9222);
  }
}
.snow:nth-child(143) {
  opacity: 0.9732;
  transform: translate(38.9849vw, -10px) scale(0.7265);
  animation: fall-143 24s -27s linear infinite;
}
@keyframes fall-143 {
  63.164% {
    transform: translate(43.8048vw, 63.164vh) scale(0.7265);
  }
  to {
    transform: translate(41.39485vw, 100vh) scale(0.7265);
  }
}
.snow:nth-child(144) {
  opacity: 0.8786;
  transform: translate(98.9968vw, -10px) scale(0.5763);
  animation: fall-144 30s -25s linear infinite;
}
@keyframes fall-144 {
  45.115% {
    transform: translate(96.3663vw, 45.115vh) scale(0.5763);
  }
  to {
    transform: translate(97.68155vw, 100vh) scale(0.5763);
  }
}
.snow:nth-child(145) {
  opacity: 0.8383;
  transform: translate(92.1556vw, -10px) scale(0.9835);
  animation: fall-145 27s -24s linear infinite;
}
@keyframes fall-145 {
  30.878% {
    transform: translate(90.1365vw, 30.878vh) scale(0.9835);
  }
  to {
    transform: translate(91.14605vw, 100vh) scale(0.9835);
  }
}
.snow:nth-child(146) {
  opacity: 0.9784;
  transform: translate(75.1466vw, -10px) scale(0.5855);
  animation: fall-146 22s -12s linear infinite;
}
@keyframes fall-146 {
  59.361% {
    transform: translate(66.9444vw, 59.361vh) scale(0.5855);
  }
  to {
    transform: translate(71.0455vw, 100vh) scale(0.5855);
  }
}
.snow:nth-child(147) {
  opacity: 0.7502;
  transform: translate(35.5422vw, -10px) scale(0.1886);
  animation: fall-147 30s -19s linear infinite;
}
@keyframes fall-147 {
  40.929% {
    transform: translate(35.1529vw, 40.929vh) scale(0.1886);
  }
  to {
    transform: translate(35.34755vw, 100vh) scale(0.1886);
  }
}
.snow:nth-child(148) {
  opacity: 0.7053;
  transform: translate(33.2517vw, -10px) scale(0.8809);
  animation: fall-148 28s -20s linear infinite;
}
@keyframes fall-148 {
  33.917% {
    transform: translate(30.3616vw, 33.917vh) scale(0.8809);
  }
  to {
    transform: translate(31.80665vw, 100vh) scale(0.8809);
  }
}
.snow:nth-child(149) {
  opacity: 0.2184;
  transform: translate(48.5162vw, -10px) scale(0.0315);
  animation: fall-149 24s -29s linear infinite;
}
@keyframes fall-149 {
  64.52% {
    transform: translate(42.2207vw, 64.52vh) scale(0.0315);
  }
  to {
    transform: translate(45.36845vw, 100vh) scale(0.0315);
  }
}
.snow:nth-child(150) {
  opacity: 0.9124;
  transform: translate(36.0738vw, -10px) scale(0.0228);
  animation: fall-150 16s -26s linear infinite;
}
@keyframes fall-150 {
  71.639% {
    transform: translate(28.6273vw, 71.639vh) scale(0.0228);
  }
  to {
    transform: translate(32.35055vw, 100vh) scale(0.0228);
  }
}
.snow:nth-child(151) {
  opacity: 0.1691;
  transform: translate(93.1616vw, -10px) scale(0.6504);
  animation: fall-151 30s -11s linear infinite;
}
@keyframes fall-151 {
  58.378% {
    transform: translate(95.539vw, 58.378vh) scale(0.6504);
  }
  to {
    transform: translate(94.3503vw, 100vh) scale(0.6504);
  }
}
.snow:nth-child(152) {
  opacity: 0.5184;
  transform: translate(66.0771vw, -10px) scale(0.3065);
  animation: fall-152 16s -13s linear infinite;
}
@keyframes fall-152 {
  53.879% {
    transform: translate(59.3212vw, 53.879vh) scale(0.3065);
  }
  to {
    transform: translate(62.69915vw, 100vh) scale(0.3065);
  }
}
.snow:nth-child(153) {
  opacity: 0.1027;
  transform: translate(43.3824vw, -10px) scale(0.052);
  animation: fall-153 22s -15s linear infinite;
}
@keyframes fall-153 {
  59.799% {
    transform: translate(42.1154vw, 59.799vh) scale(0.052);
  }
  to {
    transform: translate(42.7489vw, 100vh) scale(0.052);
  }
}
.snow:nth-child(154) {
  opacity: 0.3688;
  transform: translate(96.288vw, -10px) scale(0.4632);
  animation: fall-154 22s -21s linear infinite;
}
@keyframes fall-154 {
  74.584% {
    transform: translate(86.7469vw, 74.584vh) scale(0.4632);
  }
  to {
    transform: translate(91.51745vw, 100vh) scale(0.4632);
  }
}
.snow:nth-child(155) {
  opacity: 0.7582;
  transform: translate(61.7844vw, -10px) scale(0.21);
  animation: fall-155 14s -9s linear infinite;
}
@keyframes fall-155 {
  72.824% {
    transform: translate(67.9521vw, 72.824vh) scale(0.21);
  }
  to {
    transform: translate(64.86825vw, 100vh) scale(0.21);
  }
}
.snow:nth-child(156) {
  opacity: 0.2412;
  transform: translate(84.1807vw, -10px) scale(0.4441);
  animation: fall-156 29s -12s linear infinite;
}
@keyframes fall-156 {
  41.287% {
    transform: translate(77.1976vw, 41.287vh) scale(0.4441);
  }
  to {
    transform: translate(80.68915vw, 100vh) scale(0.4441);
  }
}
.snow:nth-child(157) {
  opacity: 0.4899;
  transform: translate(92.8617vw, -10px) scale(0.3346);
  animation: fall-157 21s -23s linear infinite;
}
@keyframes fall-157 {
  53.253% {
    transform: translate(88.5421vw, 53.253vh) scale(0.3346);
  }
  to {
    transform: translate(90.7019vw, 100vh) scale(0.3346);
  }
}
.snow:nth-child(158) {
  opacity: 0.5163;
  transform: translate(65.8132vw, -10px) scale(0.1379);
  animation: fall-158 16s -7s linear infinite;
}
@keyframes fall-158 {
  68.013% {
    transform: translate(56.1646vw, 68.013vh) scale(0.1379);
  }
  to {
    transform: translate(60.9889vw, 100vh) scale(0.1379);
  }
}
.snow:nth-child(159) {
  opacity: 0.5515;
  transform: translate(29.7862vw, -10px) scale(0.8693);
  animation: fall-159 10s -25s linear infinite;
}
@keyframes fall-159 {
  31.191% {
    transform: translate(37.6925vw, 31.191vh) scale(0.8693);
  }
  to {
    transform: translate(33.73935vw, 100vh) scale(0.8693);
  }
}
.snow:nth-child(160) {
  opacity: 0.0577;
  transform: translate(19.8411vw, -10px) scale(0.245);
  animation: fall-160 29s -10s linear infinite;
}
@keyframes fall-160 {
  45.816% {
    transform: translate(16.9683vw, 45.816vh) scale(0.245);
  }
  to {
    transform: translate(18.4047vw, 100vh) scale(0.245);
  }
}
.snow:nth-child(161) {
  opacity: 0.4916;
  transform: translate(27.5087vw, -10px) scale(0.8321);
  animation: fall-161 28s -28s linear infinite;
}
@keyframes fall-161 {
  79.898% {
    transform: translate(34.8064vw, 79.898vh) scale(0.8321);
  }
  to {
    transform: translate(31.15755vw, 100vh) scale(0.8321);
  }
}
.snow:nth-child(162) {
  opacity: 0.6152;
  transform: translate(88.7448vw, -10px) scale(0.64);
  animation: fall-162 17s -10s linear infinite;
}
@keyframes fall-162 {
  30.077% {
    transform: translate(93.781vw, 30.077vh) scale(0.64);
  }
  to {
    transform: translate(91.2629vw, 100vh) scale(0.64);
  }
}
.snow:nth-child(163) {
  opacity: 0.1118;
  transform: translate(37.776vw, -10px) scale(0.8413);
  animation: fall-163 18s -12s linear infinite;
}
@keyframes fall-163 {
  73.263% {
    transform: translate(32.0254vw, 73.263vh) scale(0.8413);
  }
  to {
    transform: translate(34.9007vw, 100vh) scale(0.8413);
  }
}
.snow:nth-child(164) {
  opacity: 0.3044;
  transform: translate(33.9288vw, -10px) scale(0.721);
  animation: fall-164 29s -18s linear infinite;
}
@keyframes fall-164 {
  72.401% {
    transform: translate(34.5642vw, 72.401vh) scale(0.721);
  }
  to {
    transform: translate(34.2465vw, 100vh) scale(0.721);
  }
}
.snow:nth-child(165) {
  opacity: 0.8839;
  transform: translate(70.4227vw, -10px) scale(0.2843);
  animation: fall-165 24s -22s linear infinite;
}
@keyframes fall-165 {
  39.88% {
    transform: translate(63.3705vw, 39.88vh) scale(0.2843);
  }
  to {
    transform: translate(66.8966vw, 100vh) scale(0.2843);
  }
}
.snow:nth-child(166) {
  opacity: 0.8289;
  transform: translate(82.2668vw, -10px) scale(0.9978);
  animation: fall-166 23s -27s linear infinite;
}
@keyframes fall-166 {
  72.599% {
    transform: translate(79.7356vw, 72.599vh) scale(0.9978);
  }
  to {
    transform: translate(81.0012vw, 100vh) scale(0.9978);
  }
}
.snow:nth-child(167) {
  opacity: 0.1261;
  transform: translate(97.3742vw, -10px) scale(0.0027);
  animation: fall-167 22s -18s linear infinite;
}
@keyframes fall-167 {
  35.291% {
    transform: translate(97.0203vw, 35.291vh) scale(0.0027);
  }
  to {
    transform: translate(97.19725vw, 100vh) scale(0.0027);
  }
}
.snow:nth-child(168) {
  opacity: 0.2909;
  transform: translate(13.3851vw, -10px) scale(0.6427);
  animation: fall-168 11s -2s linear infinite;
}
@keyframes fall-168 {
  45.067% {
    transform: translate(7.2106vw, 45.067vh) scale(0.6427);
  }
  to {
    transform: translate(10.29785vw, 100vh) scale(0.6427);
  }
}
.snow:nth-child(169) {
  opacity: 0.4379;
  transform: translate(31.7492vw, -10px) scale(0.8661);
  animation: fall-169 30s -1s linear infinite;
}
@keyframes fall-169 {
  39.556% {
    transform: translate(33.2052vw, 39.556vh) scale(0.8661);
  }
  to {
    transform: translate(32.4772vw, 100vh) scale(0.8661);
  }
}
.snow:nth-child(170) {
  opacity: 0.4751;
  transform: translate(2.7252vw, -10px) scale(0.9915);
  animation: fall-170 14s -15s linear infinite;
}
@keyframes fall-170 {
  70.991% {
    transform: translate(12.3246vw, 70.991vh) scale(0.9915);
  }
  to {
    transform: translate(7.5249vw, 100vh) scale(0.9915);
  }
}
.snow:nth-child(171) {
  opacity: 0.1409;
  transform: translate(82.9061vw, -10px) scale(0.4014);
  animation: fall-171 15s -17s linear infinite;
}
@keyframes fall-171 {
  55.009% {
    transform: translate(86.1136vw, 55.009vh) scale(0.4014);
  }
  to {
    transform: translate(84.50985vw, 100vh) scale(0.4014);
  }
}
.snow:nth-child(172) {
  opacity: 0.4833;
  transform: translate(69.9907vw, -10px) scale(0.0379);
  animation: fall-172 17s -24s linear infinite;
}
@keyframes fall-172 {
  49.204% {
    transform: translate(78.4749vw, 49.204vh) scale(0.0379);
  }
  to {
    transform: translate(74.2328vw, 100vh) scale(0.0379);
  }
}
.snow:nth-child(173) {
  opacity: 0.0945;
  transform: translate(74.5294vw, -10px) scale(0.7976);
  animation: fall-173 17s -22s linear infinite;
}
@keyframes fall-173 {
  49.068% {
    transform: translate(83.7966vw, 49.068vh) scale(0.7976);
  }
  to {
    transform: translate(79.163vw, 100vh) scale(0.7976);
  }
}
.snow:nth-child(174) {
  opacity: 0.5838;
  transform: translate(44.172vw, -10px) scale(0.0184);
  animation: fall-174 28s -8s linear infinite;
}
@keyframes fall-174 {
  70.465% {
    transform: translate(49.5787vw, 70.465vh) scale(0.0184);
  }
  to {
    transform: translate(46.87535vw, 100vh) scale(0.0184);
  }
}
.snow:nth-child(175) {
  opacity: 0.518;
  transform: translate(79.5235vw, -10px) scale(0.7557);
  animation: fall-175 25s -12s linear infinite;
}
@keyframes fall-175 {
  53.732% {
    transform: translate(71.8752vw, 53.732vh) scale(0.7557);
  }
  to {
    transform: translate(75.69935vw, 100vh) scale(0.7557);
  }
}
.snow:nth-child(176) {
  opacity: 0.9631;
  transform: translate(90.6594vw, -10px) scale(0.5128);
  animation: fall-176 25s -7s linear infinite;
}
@keyframes fall-176 {
  56.914% {
    transform: translate(84.9097vw, 56.914vh) scale(0.5128);
  }
  to {
    transform: translate(87.78455vw, 100vh) scale(0.5128);
  }
}
.snow:nth-child(177) {
  opacity: 0.9356;
  transform: translate(53.015vw, -10px) scale(0.8533);
  animation: fall-177 14s -7s linear infinite;
}
@keyframes fall-177 {
  74.879% {
    transform: translate(51.3158vw, 74.879vh) scale(0.8533);
  }
  to {
    transform: translate(52.1654vw, 100vh) scale(0.8533);
  }
}
.snow:nth-child(178) {
  opacity: 0.163;
  transform: translate(0.6335vw, -10px) scale(0.7883);
  animation: fall-178 10s -10s linear infinite;
}
@keyframes fall-178 {
  65.919% {
    transform: translate(3.9489vw, 65.919vh) scale(0.7883);
  }
  to {
    transform: translate(2.2912vw, 100vh) scale(0.7883);
  }
}
.snow:nth-child(179) {
  opacity: 0.0109;
  transform: translate(58.9775vw, -10px) scale(0.0238);
  animation: fall-179 20s -25s linear infinite;
}
@keyframes fall-179 {
  44.415% {
    transform: translate(59.3924vw, 44.415vh) scale(0.0238);
  }
  to {
    transform: translate(59.18495vw, 100vh) scale(0.0238);
  }
}
.snow:nth-child(180) {
  opacity: 0.3141;
  transform: translate(20.3892vw, -10px) scale(0.2286);
  animation: fall-180 27s -29s linear infinite;
}
@keyframes fall-180 {
  68.842% {
    transform: translate(10.4302vw, 68.842vh) scale(0.2286);
  }
  to {
    transform: translate(15.4097vw, 100vh) scale(0.2286);
  }
}
.snow:nth-child(181) {
  opacity: 0.2643;
  transform: translate(24.1289vw, -10px) scale(0.2017);
  animation: fall-181 17s -1s linear infinite;
}
@keyframes fall-181 {
  47.803% {
    transform: translate(16.0864vw, 47.803vh) scale(0.2017);
  }
  to {
    transform: translate(20.10765vw, 100vh) scale(0.2017);
  }
}
.snow:nth-child(182) {
  opacity: 0.2258;
  transform: translate(88.6473vw, -10px) scale(0.4974);
  animation: fall-182 17s -12s linear infinite;
}
@keyframes fall-182 {
  30.173% {
    transform: translate(94.7142vw, 30.173vh) scale(0.4974);
  }
  to {
    transform: translate(91.68075vw, 100vh) scale(0.4974);
  }
}
.snow:nth-child(183) {
  opacity: 0.6405;
  transform: translate(96.5374vw, -10px) scale(0.997);
  animation: fall-183 21s -9s linear infinite;
}
@keyframes fall-183 {
  75.189% {
    transform: translate(91.764vw, 75.189vh) scale(0.997);
  }
  to {
    transform: translate(94.1507vw, 100vh) scale(0.997);
  }
}
.snow:nth-child(184) {
  opacity: 0.5991;
  transform: translate(47.0934vw, -10px) scale(0.7642);
  animation: fall-184 13s -21s linear infinite;
}
@keyframes fall-184 {
  59.185% {
    transform: translate(39.6135vw, 59.185vh) scale(0.7642);
  }
  to {
    transform: translate(43.35345vw, 100vh) scale(0.7642);
  }
}
.snow:nth-child(185) {
  opacity: 0.8108;
  transform: translate(67.2973vw, -10px) scale(0.2916);
  animation: fall-185 13s -7s linear infinite;
}
@keyframes fall-185 {
  44.834% {
    transform: translate(59.3721vw, 44.834vh) scale(0.2916);
  }
  to {
    transform: translate(63.3347vw, 100vh) scale(0.2916);
  }
}
.snow:nth-child(186) {
  opacity: 0.7264;
  transform: translate(30.5187vw, -10px) scale(0.1803);
  animation: fall-186 19s -9s linear infinite;
}
@keyframes fall-186 {
  52.959% {
    transform: translate(24.5989vw, 52.959vh) scale(0.1803);
  }
  to {
    transform: translate(27.5588vw, 100vh) scale(0.1803);
  }
}
.snow:nth-child(187) {
  opacity: 0.7872;
  transform: translate(60.1903vw, -10px) scale(0.1112);
  animation: fall-187 23s -1s linear infinite;
}
@keyframes fall-187 {
  50.04% {
    transform: translate(60.392vw, 50.04vh) scale(0.1112);
  }
  to {
    transform: translate(60.29115vw, 100vh) scale(0.1112);
  }
}
.snow:nth-child(188) {
  opacity: 0.1171;
  transform: translate(91.1937vw, -10px) scale(0.5731);
  animation: fall-188 15s -14s linear infinite;
}
@keyframes fall-188 {
  57.759% {
    transform: translate(86.2922vw, 57.759vh) scale(0.5731);
  }
  to {
    transform: translate(88.74295vw, 100vh) scale(0.5731);
  }
}
.snow:nth-child(189) {
  opacity: 0.2963;
  transform: translate(3.4933vw, -10px) scale(0.5903);
  animation: fall-189 28s -7s linear infinite;
}
@keyframes fall-189 {
  34.805% {
    transform: translate(10.3373vw, 34.805vh) scale(0.5903);
  }
  to {
    transform: translate(6.9153vw, 100vh) scale(0.5903);
  }
}
.snow:nth-child(190) {
  opacity: 0.1909;
  transform: translate(97.6497vw, -10px) scale(0.2695);
  animation: fall-190 21s -10s linear infinite;
}
@keyframes fall-190 {
  78.191% {
    transform: translate(106.6263vw, 78.191vh) scale(0.2695);
  }
  to {
    transform: translate(102.138vw, 100vh) scale(0.2695);
  }
}
.snow:nth-child(191) {
  opacity: 0.8791;
  transform: translate(15.3804vw, -10px) scale(0.1426);
  animation: fall-191 23s -14s linear infinite;
}
@keyframes fall-191 {
  55.089% {
    transform: translate(8.3021vw, 55.089vh) scale(0.1426);
  }
  to {
    transform: translate(11.84125vw, 100vh) scale(0.1426);
  }
}
.snow:nth-child(192) {
  opacity: 0.3876;
  transform: translate(75.7943vw, -10px) scale(0.2621);
  animation: fall-192 29s -13s linear infinite;
}
@keyframes fall-192 {
  43.034% {
    transform: translate(84.0223vw, 43.034vh) scale(0.2621);
  }
  to {
    transform: translate(79.9083vw, 100vh) scale(0.2621);
  }
}
.snow:nth-child(193) {
  opacity: 0.6009;
  transform: translate(94.162vw, -10px) scale(0.1745);
  animation: fall-193 26s -29s linear infinite;
}
@keyframes fall-193 {
  54.498% {
    transform: translate(101.9025vw, 54.498vh) scale(0.1745);
  }
  to {
    transform: translate(98.03225vw, 100vh) scale(0.1745);
  }
}
.snow:nth-child(194) {
  opacity: 0.1705;
  transform: translate(40.7469vw, -10px) scale(0.9953);
  animation: fall-194 23s -26s linear infinite;
}
@keyframes fall-194 {
  50.011% {
    transform: translate(33.408vw, 50.011vh) scale(0.9953);
  }
  to {
    transform: translate(37.07745vw, 100vh) scale(0.9953);
  }
}
.snow:nth-child(195) {
  opacity: 0.0505;
  transform: translate(22.6157vw, -10px) scale(0.9752);
  animation: fall-195 17s -26s linear infinite;
}
@keyframes fall-195 {
  71.599% {
    transform: translate(19.5015vw, 71.599vh) scale(0.9752);
  }
  to {
    transform: translate(21.0586vw, 100vh) scale(0.9752);
  }
}
.snow:nth-child(196) {
  opacity: 0.9793;
  transform: translate(54.7324vw, -10px) scale(0.6733);
  animation: fall-196 18s -8s linear infinite;
}
@keyframes fall-196 {
  70.787% {
    transform: translate(49.0314vw, 70.787vh) scale(0.6733);
  }
  to {
    transform: translate(51.8819vw, 100vh) scale(0.6733);
  }
}
.snow:nth-child(197) {
  opacity: 0.4014;
  transform: translate(10.8843vw, -10px) scale(0.5447);
  animation: fall-197 21s -26s linear infinite;
}
@keyframes fall-197 {
  79.344% {
    transform: translate(4.0973vw, 79.344vh) scale(0.5447);
  }
  to {
    transform: translate(7.4908vw, 100vh) scale(0.5447);
  }
}
.snow:nth-child(198) {
  opacity: 0.6979;
  transform: translate(40.3118vw, -10px) scale(0.2009);
  animation: fall-198 12s -13s linear infinite;
}
@keyframes fall-198 {
  61.837% {
    transform: translate(36.7173vw, 61.837vh) scale(0.2009);
  }
  to {
    transform: translate(38.51455vw, 100vh) scale(0.2009);
  }
}
.snow:nth-child(199) {
  opacity: 0.5402;
  transform: translate(3.5585vw, -10px) scale(0.4174);
  animation: fall-199 18s -19s linear infinite;
}
@keyframes fall-199 {
  37.641% {
    transform: translate(-1.1243vw, 37.641vh) scale(0.4174);
  }
  to {
    transform: translate(1.2171vw, 100vh) scale(0.4174);
  }
}
.snow:nth-child(200) {
  opacity: 0.9742;
  transform: translate(73.8616vw, -10px) scale(0.5054);
  animation: fall-200 15s -29s linear infinite;
}
@keyframes fall-200 {
  44.188% {
    transform: translate(71.3137vw, 44.188vh) scale(0.5054);
  }
  to {
    transform: translate(72.58765vw, 100vh) scale(0.5054);
  }
}

/* LIGTS END */
</style>

<style lang="scss">
@import "~bulma/sass/utilities/_all";
$my-primary: #99cca9;
$link: #99cca9;
$primary-invert: white;
$colors: (
  "primary": (
    $my-primary,
    $primary-invert,
  ),
  "pagination-focus-border-color": (
    #99cca9,
    black,
  ),
);
// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";
</style>
